import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATALOG, waLink } from "../data/site";

const ease = [0.22, 1, 0.36, 1];

const ProductCard = ({ p, i }) => (
  <motion.article
    data-testid={`product-card-${p.id}`}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.6, delay: (i % 4) * 0.06, ease }}
    className="group flex flex-col bg-paper border border-ink/10 hover:border-alga transition-colors duration-300"
  >
    <div className="relative aspect-square overflow-hidden bg-paper-2">
      <img src={p.img} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-105" />
      {p.hot && <span className="absolute top-3 left-3 bg-alga text-paper text-[11px] font-bold uppercase tracking-wider px-2.5 py-1">Mais pedido</span>}
    </div>
    <div className="flex flex-col flex-1 p-4 sm:p-5">
      <h3 className="font-display text-lg sm:text-xl leading-tight">{p.title}</h3>
      <p className="mt-1.5 text-xs sm:text-sm text-ink-soft leading-snug">{p.desc}</p>
      <a
        href={waLink(`Olá, Alfa Gráfica Digital! Gostaria de um orçamento de *${p.title}*.`)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`order-btn-${p.id}`}
        className="mt-auto pt-4 inline-flex items-center justify-between gap-2 text-sm font-bold text-ink"
      >
        <span className="border-b-2 border-alga pb-0.5 sm:whitespace-nowrap text-[11px] sm:text-xs uppercase tracking-wide">Solicitar orçamento</span>
        <span className="hidden sm:grid place-items-center h-8 w-8 sm:h-9 sm:w-9 shrink-0 rounded-full bg-ink text-paper transition-[background-color,transform] duration-300 group-hover:bg-alga group-hover:rotate-45"><ArrowUpRight className="h-4 w-4" /></span>
      </a>
    </div>
  </motion.article>
);

export const Catalog = () => {
  const [all, setAll] = useState(false);
  const items = all ? CATALOG : CATALOG.slice(0, 8);
  return (
  <section id="produtos" data-testid="products-section" className="px-5 sm:px-10 py-20 lg:py-28 scroll-mt-6">
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-soft">( Produtos )</p>
        <h2 className="mt-4 font-display uppercase text-4xl sm:text-6xl leading-[0.95]">Mais procurados<br /><em className="text-alga">na Alfa Gráfica</em>.</h2>
      </div>
      <p className="max-w-xs text-sm text-ink-soft">Escolha o produto e solicite seu orçamento direto pelo WhatsApp.</p>
    </div>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
      {items.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
    </div>
    {CATALOG.length > 8 && (
      <div className="mt-10 flex justify-center">
        <button onClick={() => setAll((v) => !v)} data-testid="catalog-toggle-btn" className="rounded-full border-2 border-ink px-6 py-3 text-sm font-bold uppercase tracking-wide transition-[background-color,color,transform] duration-300 hover:bg-ink hover:text-paper active:scale-95">
          {all ? "Ver menos" : `Ver todos os produtos (${CATALOG.length})`}
        </button>
      </div>
    )}
  </section>
  );
};
